module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "upper-subpanel row"
  }, [_c('progressBar'), _c('div', {
    staticClass: "upper-subpanel--without-progressbar"
  }, [(_vm.getMedGroup === false && _vm.stage === 'medGroupList') ? _c('Loader') : _vm._e(), (_vm.getMedGroup && _vm.stage === 'medGroupList') ? _c('div', {
    staticClass: "med-group-wrapper"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill nav-autoix"
  }, _vm._l((_vm.group), function(g, index) {
    return _c('li', {
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          _vm.currentGroupIndex = index
        }
      }
    }, [_c('div', {
      staticClass: "nav-link",
      class: {
        'active': _vm.currentGroupIndex === index
      }
    }, [_vm._v(_vm._s(g.name))])])
  }), 0), _c('div', {
    staticClass: "med-select"
  }, _vm._l((_vm.group[_vm.currentGroupIndex].childMedSet), function(med, index) {
    return _c('div', {
      staticClass: "med-button",
      class: {
        'selected-med-button': med.selected, 'unselectable': med.amountInSystem === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectMed(index)
        }
      }
    }, [_c('div', {
      attrs: {
        "id": "med_desc"
      }
    }, [_c('h6', [_vm._v(_vm._s(med.code) + " - " + _vm._s(med.CGMH_number))]), _c('h6', [_vm._v(_vm._s(med.generic_name))])]), _c('div', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(med.amountInSystem))])])])
  }), 0)]) : _vm._e(), (_vm.stage === 'startFlow') ? _c('MultiFlow', {
    attrs: {
      "multiProgress": _vm.multiProgress,
      "confirmProgress": _vm.confirmProgress,
      "actionProgress": _vm.actionProgress
    },
    on: {
      "setAllConfirmData": _vm.getAllConfirmData
    }
  }) : _vm._e()], 1)], 1), _c('BottomButtons', [_c('action-button', {
    attrs: {
      "slot": "button-1",
      "title": "回主畫面",
      "clickable": _vm.currentApp.cancel
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    },
    slot: "button-1"
  }), (_vm.$store.state.user.user.med_app_privilege.fetch_by_schedule) ? _c('action-button', {
    attrs: {
      "slot": "button-3",
      "title": "醫囑取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'schedule',
          params: {
            stage: 'ComboMedListAndPatient'
          }
        })
      }
    },
    slot: "button-3"
  }) : _vm._e(), (_vm.$store.state.user.user.med_app_privilege.fetch_by_schedule) ? _c('action-button', {
    attrs: {
      "slot": "button-4",
      "title": "類別取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'fetchDrugGroup'
        })
      }
    },
    slot: "button-4"
  }) : _vm._e(), _c('action-button', {
    attrs: {
      "slot": "button-9",
      "title": "開始取藥"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startFlow($event)
      }
    },
    slot: "button-9"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43dced9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FetchDrugCombo.vue
// module id = 1453
// module chunks = 1